import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
`;

export const RowContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 18px;
`;

export const AlarmText = styled.span`
    width: 73px;
    color: #333;
    leading-trim: both;
    text-edge: cap;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 0%; /* 0px */
`;

export const NumberInput = styled.input`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 48px;
    border-radius: 3.802px;
    border: 1.14px solid #C4C4C4;
    outline: none;
    height: 24px;
    background: #FFF;
    box-shadow: 1.52061px 1.52061px 3.80152px 0px rgba(0, 0, 0, 0.40) inset;
    color: #333;
    font-size: 15px;
    font-weight: 600; 
    font-style: normal;
    line-height: 0;
    &::-webkit-inner-spin-button{
        -webkit-appearance: none;
    }
`;
